import { initializeApp } from "firebase/app";
import { getFunctions } from 'firebase/functions';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAs4NljcWOHrofRHVU_zPlJTLsBaHA_NP0",
  authDomain: "cndsoftware-70b14.firebaseapp.com",
  projectId: "cndsoftware-70b14",
  storageBucket: "cndsoftware-70b14.firebasestorage.app",
  messagingSenderId: "593362122599",
  appId: "1:593362122599:web:f308adbb7c310b5f4921c2",
  measurementId: "G-NS2E44KKHL"
};

const app = initializeApp(firebaseConfig);

export const functions = getFunctions(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
